
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ExpandableList extends Vue {
  @Prop({ required: true, default: () => [] }) items!: { id: string; [key: string]: unknown }[]
  @Prop({ required: false, default: false }) expand!: boolean
  @Prop({ required: false, default: 3 }) defaultVisibleCount!: number

  enter(el: HTMLElement) {
    el.style.overflow = 'hidden'

    const offsetHeight = el.offsetHeight
    // Set the height of the element to 0 to enable the transition from 0 to auto
    el.style.height = '0'

    requestAnimationFrame(() => {
      el.style.height = offsetHeight + 'px'
    })
  }

  leave(el: HTMLElement) {
    el.style.overflow = 'hidden'
    // Set the height of the element to its current height to enable the transition from auto to 0
    el.style.height = el.offsetHeight + 'px'

    requestAnimationFrame(() => {
      el.style.height = '0'
    })
  }

  get visibleItems() {
    return this.expand ? this.items : this.items.slice(0, this.defaultVisibleCount)
  }

  get toggleLabel() {
    return this.expand
      ? this.$t('global.showLess')
      : `${this.$t('global.showMore')} (${this.items.length - this.defaultVisibleCount})`
  }
}
